// Hooks
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'checkAlias'];

export function useCheckAlias(aliasToCheck: string | undefined) {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useQuery({
    enabled: !!aliasToCheck,
    queryKey: MUTATION_PREFIX.concat([aliasToCheck ?? '']),
    queryFn: async () => {
      const response = await client.getPeople({ aliases: aliasToCheck });
      return response.people;
    },
  });
}
